/*
 * @Author: wangshengqiang
 * @Date: 2022-03-01 11:00:37
 * @LastEditTime: 2022-03-16 18:40:43
 * @LastEditors: wangshengqiang
 * @Description:
 */
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from '@/store/context';
export default (() => {
  const form = useFormContext();
  return {
    form
  };
});